/**
 * @Time    : 2024/1/12 15:42
 * @Author  : tlovet
 * @Software: WebStorm
 */

/** 全局cookie方法 */

import type { CookieAttributes } from 'js-cookie';
import Cookies from 'js-cookie';

// 获取cookie的值
export const getCookie = (cname: string) => {
  try {
    return Cookies.get(cname);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('get cookie fail.', err);
    return '';
  }
};

// 设置cookie的值, expires为数字时代表天，时间格式时代表指定的到期时间
export const setCookie = (cname: string, value: string | any, expires: number | Date) => {
  const cookieOptions: CookieAttributes = {
    expires,
    secure: false, // 域名为https时改为true
    // sameSite: 'None',
    HttpOnly: false,
  };
  try {
    if (typeof value === 'object') {
      Cookies.set(cname, JSON.stringify(value), cookieOptions);
    } else {
      Cookies.set(cname, value, cookieOptions);
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('set cookie fail.', err);
  }
};

// 删除cookie的值
export const delCookie = (cname: string) => {
  try {
    Cookies.remove(cname);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log('del cookie fail.', err);
  }
};
